import { styled, themeGet } from '@qwealth/qcore';

export const StyledDocumentButton = styled.button`
  background-color: ${themeGet('colors.gray.4')};
  border: none;
  width: 98%;
  text-align: left;
  border-radius: ${themeGet('radii.large')};
  color: ${themeGet('colors.dark')};
  font-weight: ${themeGet('fontWeights.bold')};
  transition: all 0.15s ease-in-out;

  &:hover {
    background-color: ${themeGet('colors.gray.3')};
    color: ${themeGet('colors.primaryLight.1')};
    transform: translateY(-1px);
  }
`;
